module.exports = __webpack_public_path__ + "img/Devices-background-green.6dc424e0.svg";